import React from "react"
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined"
import InstagramIcon from "@mui/icons-material/Instagram"
import LocationOnIcon from "@mui/icons-material/LocationOn"
import LocalPhoneIcon from "@mui/icons-material/LocalPhone"
import EmailIcon from "@mui/icons-material/Email"
import {
  Container,
  Left,
  Logo,
  Desc,
  SocialContainer,
  SocialIcon,
  Center,
  Title,
  List,
  ListItem,
  Right,
  ContactItem,
  StyledLink,
} from "../styles/FooterStyle"

const Footer = () => {
  return (
    <Container>
      <Left>
        <Logo>Store</Logo>
        <Desc>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis
          sapiente temporibus minima nesciunt tempora! Rerum.
        </Desc>
        <SocialContainer>
          <SocialIcon>
            <FacebookOutlinedIcon />
          </SocialIcon>
          <SocialIcon>
            <InstagramIcon />
          </SocialIcon>
        </SocialContainer>
      </Left>
      <Center>
        <Title>Links</Title>
        <List>
          <StyledLink to='/'>
            <ListItem>Home</ListItem>
          </StyledLink>
          <StyledLink to='/products'>
            <ListItem>Products</ListItem>
          </StyledLink>
          <StyledLink to='/cart'>
            <ListItem>Cart</ListItem>
          </StyledLink>
        </List>
      </Center>
      <Right>
        <Title>Contact</Title>
        <ContactItem>
          <LocationOnIcon sx={{ color: "#4c87ef" }} />
          25 rue des oranges
        </ContactItem>
        <ContactItem>
          <LocalPhoneIcon sx={{ color: "#4c87ef" }} />
          +213 0656331111
        </ContactItem>
        <ContactItem>
          <EmailIcon sx={{ color: "#4c87ef" }} />
          exemple@gmail.com
        </ContactItem>
      </Right>
    </Container>
  )
}

export default Footer
